import { Command, OptionIcon } from 'lucide-react';
import { getSystem } from '../platform/dom/system';
import { cn } from '../platform/dom/cn';

export function ModifierKey(props: { className?: string }) {
  return getSystem() === 'win' ? (
    <span className={props.className}>Ctrl</span>
  ) : (
    <Command className={cn(props.className, 'size-[1em]!')} />
  );
}

export function ControlKey(props: { className?: string }) {
  return getSystem() === 'win' ? <span>Ctrl</span> : <span>^</span>;
}

export function AltKey(props: { className?: string }) {
  return getSystem() === 'win' ? (
    <span>Alt</span>
  ) : (
    <OptionIcon className={cn(props.className, 'size-[1em]!')} />
  );
}
